"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M7.83 5H19v11.17zm8.34 14-2-2H6l3-4 2 2.72.84-1.05L5 7.83V19z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M5.83 3H19c1.1 0 2 .9 2 2v13.17l-2-2V5H7.83zm14.66 20.31L18.17 21H5c-1.1 0-2-.9-2-2V5.83L.69 3.51 2.1 2.1l1.49 1.49L5 5l8.11 8.11 2.69 2.69L19 19l1.41 1.41 1.49 1.49zM16.17 19l-2-2H6l3-4 2 2.72.84-1.05L5 7.83V19z"
}, "1")], 'ImageNotSupportedTwoTone');